import { useQuery } from '@tanstack/react-query';
import { fetchTaskDetail, type ApprovalDetail } from '@/services/approval-api';

export function useApprovalDetail(id: string | null) {
  return useQuery<ApprovalDetail>({
    queryKey: ['approval', 'detail', id],
    queryFn: () => fetchTaskDetail(id!),
    enabled: Boolean(id),
    staleTime: 15_000,
  });
}
